import { inferAdditionalFields } from 'better-auth/client/plugins';
import { createAuthClient } from 'better-auth/react';

export const authClient = createAuthClient({
  // Resolve fetch per call: better-fetch otherwise captures it at import time, before msw patches it in tests.
  fetchOptions: { catchAllError: true, customFetchImpl: (input, init) => globalThis.fetch(input, init) },
  plugins: [inferAdditionalFields({ user: { timezone: { type: 'string', required: false } } })],
});
